import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Table from "../../../../core/common/dataTable/index";
import { exam } from "../../../../core/data/json/exam";
import dayjs from "dayjs";
import { all_routes } from "../../../router/all_routes";
import { useUserPermissions } from "../../../UserPermissionsContext";
import Cookies from "js-cookie";
import Spin from "antd/es/spin";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import { DateRange } from "react-date-range";
import { CloseCircleOutlined } from "@ant-design/icons";
import { InputNumber, Select } from "antd";

type Permission = { id: number; name: string };
type Admin = {
  id: number;
  username: string;
  total_calls: number;
  total_duration: string;
  students_connected: number;
  total_answered_calls_by_agent: number;
  total_answered_calls_by_parent: number;
  total_missed_calls_by_agent: number;
  total_missed_calls_by_parent: number;
  last_call_date: string | null;
};

type Branch = {
  branch_id: number;
  name: string;
};

type Agent = {
  id: number;
  username: string;
};

const WizklubBranchDetailCvr = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const data = exam;
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Month is zero-based, so we add 1
  const day = String(today.getDate()).padStart(2, "0");
  const formattedDate = `${month}-${day}-${year}`;
  const defaultValue = dayjs(formattedDate);
  const jwtToken = Cookies.get("authToken");
  const { userPermissions, webApi } = useUserPermissions();
  const [isLoading, setIsLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [permissions, setPermissions] = useState<Permission[]>([]);
  const [admin, setAdmin] = useState<Admin[]>([]);
  const [from, setFrom] = useState();
  const [to, setTo] = useState<number>();
  const [totalCount, setTotalCount] = useState();
  const [toastMessage, setToastMessage] = useState("");
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [currentPage, setCurrentPage] = useState(() => {
    const savedPage = localStorage.getItem("wizklubBranchDetailCvrCurrentPage");
    return savedPage ? JSON.parse(savedPage) : 1;
  });
  useEffect(() => {
    localStorage.setItem("wizklubBranchDetailCvrCurrentPage", JSON.stringify(currentPage));
  }, [currentPage]);
  const [pageSize, setPageSize] = useState<number>(() => {
    const savedPageSize = localStorage.getItem("wizklubBranchDetailCvrPageSize");
    return savedPageSize ? Number(savedPageSize) : 10;
  });

  useEffect(() => {
    localStorage.setItem("wizklubBranchDetailCvrPageSize", pageSize.toString());
  }, [pageSize]);
 const [searchText, setSearchText] = useState<string>(() => {
  return localStorage.getItem("wizklubBranchDetailCvrSearchText") || "";
});

useEffect(() => {
  localStorage.setItem(
    "wizklubBranchDetailCvrSearchText",
    searchText
  );
}, [searchText]);
  const [showDateRange, setShowDateRange] = useState(false);
  const [showCalendar1, setShowCalendar1] = useState(false);
  const [noSaleDays, setNoSaleDays] = useState("");
  const handleClearBranch = () => setSelectedBranch(0);
  const handleClearAgent = () => setSelectedAgent(0);
  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject,
    );
  };
  const [columnDetails, setColumnDetails] = useState<Record<string, string>>(
    {},
  );
  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(new Date().setHours(0, 0, 0, 0)),
      endDate: new Date(new Date().setHours(0, 0, 0, 0)),
      key: "selection",
    },
  ]);
  const [selectedBranch, setSelectedBranch] = useState<number>(
    Number(localStorage.getItem("selectedBranchInBranchDetailCvr")) || 0,
  );
  const [branches, setBranches] = useState<Branch[]>([]);
  const [showFilter, setShowFilter] = useState(false);
  const [modalSelectedBranch, setModalSelectedBranch] = useState<number>(0);
  const [modalSelectedAgent, setModalSelectedAgent] = useState<number>(0);
  const [selectedAgent, setSelectedAgent] = useState<number>(
    Number(localStorage.getItem("selectedAgentInBranchDetailCvr")) || 0,
  );

  useEffect(() => {
    localStorage.setItem(
      "selectedAgentInBranchDetailCvr",
      selectedAgent.toString(),
    );
  }, [selectedAgent]);
  const [agents, setAgents] = useState<Agent[]>([]);
  useEffect(() => {
    localStorage.setItem(
      "selectedBranchInBranchDetailCvr",
      selectedBranch.toString(),
    );
  }, [selectedBranch]);
  const startDate = format(dateRange[0].startDate, "yyyy-MM-dd");
  const endDate = format(dateRange[0].endDate, "yyyy-MM-dd");

  useEffect(() => {
    if (!checkPermission("view_branchdetailcvr", "branchcvr")) {
      navigate(routes.crmLandingPage);
    } else {
      fetchData(currentPage, pageSize, searchText);
      fetchBranches();
      fetchAgents();
    }
  }, [userPermissions]);

  useEffect(() => {
    fetchData(currentPage, pageSize, searchText);
  }, [noSaleDays, selectedBranch, selectedAgent, currentPage, pageSize]);

  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }
  };

  const getModalContainer = () => {
    const modalElement = document.getElementById("modal-datepicker");
    return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
  };

  const fetchBranches = async () => {
    try {
      const response = await fetch(
        `${webApi}/wizklubcvr/wizklub_branches_dropdown_for_branch_detail_cvr/`,
        options,
      );
      const data = await response.json();
      setBranches(data);
    } catch (error) {
      console.error("Failed to fetch agents", error);
    }
  };

  const fetchAgents = async () => {
    try {
      const response = await fetch(
        `${webApi}/wizklubcvr/get_agents_dropdown_for_branch_detail_cvr/`,
        options,
      );
      const data = await response.json();
      setAgents(data);
    } catch (error) {
      console.error("Failed to fetch agents", error);
    }
  };

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const fetchGroupsData = async (
    page: number,
    pageSize: number,
    searchText: string,
    startDate = "",
    endDate = "",
  ) => {
    let apiUrl = `${webApi}/wizklubcvr/branch_wise_cvr_details/?page=${page}&page_size=${pageSize}&search=${searchText}`;
    if (noSaleDays) {
      apiUrl += `&no_sales_days=${noSaleDays}`;
    }
    if (selectedBranch) {
      apiUrl += `&branch=${selectedBranch}`;
    }
    if (selectedAgent) {
      apiUrl += `&ist=${selectedAgent}`;
    }
    const response = await fetch(apiUrl, options);
    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === "token_not_valid") {
        navigate("/academic/sri-chaitanya/crm/landing-page");
      }
      throw new Error(errorData.detail || "Failed to fetch user data");
    }
    return await response.json();
  };

  const fetchPermissionsData = async () => {
    const resposne = await fetch(
      `${webApi}/user/get_permissions_dropdown/`,
      options,
    );
    return await resposne.json();
  };

  const fetchData = async (
    page: number,
    pageSize: number,
    searchText: string,
    startDate = "",
    endDate = "",
  ) => {
    setIsLoading(true); // Start loading
    try {
      const [groupsData] = await Promise.all([
        fetchGroupsData(page, pageSize, searchText),
        // fetchPermissionsData(),
      ]);
      setTotalPages(groupsData.total_pages);
      setAdmin(groupsData.results);
      setColumnDetails(groupsData.column_details);
      // setPermissions(permissionsData.results);

      setFrom(groupsData.from);
      setTo(groupsData.to);
      setTotalCount(groupsData.total_count);
      setToastMessage(groupsData.message || "submitted successfully!");
      setShowSuccessToast(true);
      setCurrentPage(groupsData.current_page_number);
      setTotalCount(groupsData.total_count);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  const handleTableChange = (pagination: any) => {
    const { current, pageSize } = pagination;
    setCurrentPage(current);
    setPageSize(pageSize);
    // fetchData(
    //   current,
    //   pageSize,
    //   searchText,
    //   startDate || undefined,
    //   endDate || undefined
    // ); // Fetch new data based on the updated pagination
  };

  const handleSearch = (value: string) => {
    setSearchText(value);
    // fetchData(
    //   currentPage,
    //   pageSize,
    //   value,
    //   startDate || undefined,
    //   endDate || undefined
    // );
  };

  const updateTarget = async (branchId: number, target: number) => {
    try {
      const response = await fetch(
        `${webApi}/wizklubcvr/branch_wise_cvr_details/${branchId}/`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
          body: JSON.stringify({
            target,
          }),
        },
      );

      if (!response.ok) {
        throw new Error("Failed to update target");
      }

      // message.success("Target updated successfully");
    } catch (error) {
      console.error(error);
      // message.error("Failed to update target");
    }
  };

  const columns = [
    {
      title: (
        <span>
          Branch
          {selectedBranch !== 0
            ? ` (${branches.find((branch) => branch.branch_id === selectedBranch)?.name})`
            : ""}
          {selectedBranch !== 0 && (
            <CloseCircleOutlined
              onClick={handleClearBranch}
              style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
            />
          )}
        </span>
      ),

      dataIndex: "name",
      // filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
      //   <div style={{ padding: 8 }}>
      //     <Select
      //       showSearch
      //       placeholder="Select Branch"
      //       style={{ width: 188 }}
      //       value={selectedKeys[0]}
      //       onChange={(value) => {
      //         const selected = branches.find((b) => b.branch_id === value);
      //         setSelectedKeys(selected ? [selected.name] : []);
      //         setSelectedBranch(value);
      //         confirm();
      //       }}
      //       allowClear
      //       filterOption={(input, option) =>
      //         typeof option?.children === "string" &&
      //         (option.children as string)
      //           .toLowerCase()
      //           .includes(input.toLowerCase())
      //       }
      //     >
      //       {branches.map((branch) => (
      //         <Select.Option key={branch.branch_id} value={branch.branch_id}>
      //           {branch.name}
      //         </Select.Option>
      //       ))}
      //     </Select>
      //   </div>
      // ),
    },
    {
      title: (
        <span>
          Agent
          {selectedAgent !== 0
            ? ` (${agents.find((agent) => agent.id === selectedAgent)?.username})`
            : ""}
          {selectedAgent !== 0 && (
            <CloseCircleOutlined
              onClick={handleClearAgent}
              style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
            />
          )}
        </span>
      ),
      dataIndex: "ist",
      // filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
      //   <div style={{ padding: 8 }}>
      //     <Select
      //       showSearch
      //       placeholder="Select Agent"
      //       style={{ width: 188 }}
      //       value={selectedKeys[0]}
      //       onChange={(value) => {
      //         const selected = agents.find((a) => a.id === value);
      //         setSelectedKeys(selected ? [selected.username] : []);
      //         setSelectedAgent(value);
      //         confirm();
      //       }}
      //       allowClear
      //       filterOption={(input, option) =>
      //         typeof option?.children === "string" &&
      //         (option.children as string)
      //           .toLowerCase()
      //           .includes(input.toLowerCase())
      //       }
      //     >
      //       {agents.map((agent) => (
      //         <Select.Option key={agent.id} value={agent.id}>
      //           {agent.username}
      //         </Select.Option>
      //       ))}
      //     </Select>
      //   </div>
      // ),
    },
    {
      title: "Target",
      dataIndex: "target",
      render: (text: number, record: any) =>
        checkPermission("change_branchdetailcvr_target", "branchcvr") ? (
          <InputNumber
            min={0}
            defaultValue={text}
            onBlur={(e) => {
              const value = Number((e.target as HTMLInputElement).value);

              if (value !== record.target) {
                updateTarget(record.branch_id, value);
              }
            }}
          />
        ) : (
          <span>{text}</span>
        ),
    },
    {
      title: "Achieved",
      dataIndex: "achieved",
    },
    {
      title: "Strength",
      dataIndex: "strength",
    },
    {
      title: "Unique Lead Touch",
      dataIndex: "unique_lead_touch",
    },
    {
      title: "Target CVR %",
      dataIndex: "target_cvr",
      render: (text: number, record: any) => (
        <span
          style={{
            color: record.color || "black",
            fontWeight: 600,
          }}
        >
          {text}%
        </span>
      ),
    },
    {
      title: "Current CVR %",
      dataIndex: "current_cvr_percentage",
    },
    {
      title: "Running CVR %",
      dataIndex: "running_cvr_percentage",
    },
    {
      title: "Renewals Count",
      dataIndex: "renewals_count",
    },
    {
      title: "Renewal Sales",
      dataIndex: "renewal_sales",
    },
  ];

  const [loading, setLoading] = useState(false);

  const handleExportClick = async () => {
    let apiUrl = `${webApi}/wizklubcvr/export_wizklub_branch_detail_cvr/?token=${jwtToken}&search=${searchText}`;
    if (noSaleDays) {
      apiUrl += `&no_sales_days=${noSaleDays}`;
    }
    if (selectedBranch) {
      apiUrl += `&branch=${selectedBranch}`;
    }
    if (selectedAgent) {
      apiUrl += `&ist=${selectedAgent}`;
    }
    window.location.href = apiUrl;
  };

  //   const handleFilter = () => {
  //     setSelectedBranch(modalSelectedBranch);
  //     setSelectedAgent(modalSelectedAgent);

  //     setShowFilter(false);
  //   };

  // //to reset filters
  //   const handleResetFilters = () => {
  //     setSelectedBranch(0);
  //     setSelectedAgent(0);

  //     setModalSelectedBranch(0);
  //     setModalSelectedAgent(0);

  //     setShowFilter(false);
  //   };

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Wizklub Branch Reports</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard1}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Branch Reports
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              {checkPermission("export_branchdetailcvr", "branchcvr") && (
                <button
                  className="btn btn-primary me-2"
                  onClick={handleExportClick}
                  disabled={loading}
                >
                  {loading ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : (
                    "Export"
                  )}
                </button>
              )}
            </div>
          </div>
          {/* /Page Header */}
          {/* Guardians List */}
          <div
            className="card "
            style={{
              width: "100%",
              boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
              borderRadius: "10px",
            }}
          >
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Branch Reports</h4>

              <div
                className="d-flex align-items-center flex-wrap gap-2"
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                  marginBottom: "10px",
                }}
              >
                <input
                  type="number"
                  className="form-control w-auto"
                  placeholder="No Sale Days"
                  value={noSaleDays}
                  onChange={(e) => {
                    const value = e.target.value;

                    if (value === "" || Number(value) >= 0) {
                      setNoSaleDays(value);
                    }
                  }}
                />
              </div>
            </div>
            <div className="card-body p-0 py-3">
              {/* <div
                className="serch-global text-right"
                style={{ marginRight: "15px" }}
              >
                <input
                  type="search"
                  className="form-control form-control-sm mb-3 w-auto float-end"
                  value={searchText}
                  placeholder="Search"
                  onChange={(e) => handleSearch(e.target.value)}
                  aria-controls="DataTables_Table_0"
                ></input>
              </div> */}

              {/* {showFilter && (
                <div
                  className="modal fade show"
                  style={{
                    display: "block",
                    backgroundColor: "rgba(0,0,0,0.5)",
                  }}
                >
                  <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                      <div className="modal-body">
                        <form className="px-3">
                          <div className="row">
                            <div className="col-md-6 mb-3">
                              <label className="form-label">Branch</label>

                              <Select
                                showSearch
                                placeholder="Select Branch"
                                style={{ width: "100%" }}
                                value={modalSelectedBranch || undefined}
                                onChange={(value) => {
                                  setModalSelectedBranch(value || 0);
                                }}
                                allowClear
                                optionFilterProp="children"
                                getPopupContainer={(trigger) =>
                                  trigger.parentElement!
                                }
                              >
                                {branches.map((branch) => (
                                  <Select.Option
                                    key={branch.branch_id}
                                    value={branch.branch_id}
                                  >
                                    {branch.name}
                                  </Select.Option>
                                ))}
                              </Select>
                            </div>
                            <div className="col-md-6 mb-3">
                              <label className="form-label">Agent</label>

                              <Select
                                showSearch
                                placeholder="Select Agent"
                                style={{ width: "100%" }}
                                value={modalSelectedAgent || undefined}
                                onChange={(value) => {
                                  setModalSelectedAgent(value || 0);
                                }}
                                allowClear
                                optionFilterProp="children"
                                getPopupContainer={(trigger) =>
                                  trigger.parentElement!
                                }
                              >
                                {agents.map((agent) => (
                                  <Select.Option
                                    key={agent.id}
                                    value={agent.id}
                                  >
                                    {agent.username}
                                  </Select.Option>
                                ))}
                              </Select>
                            </div>
                          </div>

                          <div className="mb-3 d-flex flex-wrap gap-2 justify-content-end">
                            <button
                              className="btn btn-primary"
                              type="button"
                              // onClick={handleFilter}
                            >
                              Filter
                            </button>

                            <button
                              className="btn btn-secondary"
                              type="reset"
                              // onClick={handleResetFilters}
                            >
                              Reset
                            </button>

                            <button
                              className="btn btn-danger"
                              type="button"
                              onClick={() => setShowFilter(false)}
                            >
                              Cancel
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              )} */}

              {isLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    height: "100vh",
                    paddingTop: "20px",
                  }}
                >
                  <Spin /> {/* Display loader while loading */}
                </div>
              ) : (
                <Table
                  columns={columns}
                  dataSource={admin}
                  Selection={false}
                  pagination={{
                    current: currentPage,
                    pageSize: pageSize,
                    locale: { items_per_page: "" },
                    nextIcon: <span>Next</span>,
                    prevIcon: <span>Prev</span>,
                    defaultPageSize: 10,
                    showSizeChanger: true,
                    total: totalCount,
                    showTotal: (total: any, range: any[]) =>
                      `${range[0]}-${range[1]} of ${total}`,
                    pageSizeOptions: ["15", "25", "50", "100"],
                  }}
                  onChange={handleTableChange} // Move this outside of pagination
                  onSearch={handleSearch}
                  searchText={searchText}
                />
              )}
            </div>
          </div>
          {/* /Guardians List */}
        </div>
      </div>
      <>
        {/* Delete Modal */}
        <div className="modal fade" id="delete-modal">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <form>
                <div className="modal-body text-center">
                  <span className="delete-icon">
                    <i className="ti ti-trash-x" />
                  </span>
                  <h4>Confirm Deletion</h4>
                  <p>
                    You want to delete all the marked items, this cant be undone
                    once you delete.
                  </p>
                  <div className="d-flex justify-content-center">
                    <Link
                      to="#"
                      className="btn btn-light me-3"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Link
                      to="#"
                      data-bs-dismiss="modal"
                      className="btn btn-danger"
                    >
                      Yes, Delete
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Delete Modal */}
      </>
    </div>
  );
};

export default WizklubBranchDetailCvr;
